import React from 'react'
import Select from 'react-select'

const TimezoneSelector = ({ timezone, onChange, menuPortalTarget, menuPosition, styles }) => {
  const timezoneList = Intl.supportedValuesOf('timeZone').map(tz => ({
    value: tz,
    label: tz,
  }))

  const timezoneOption = timezoneList.find(option =>
    option.value === timezone
  )

  const handleTimezoneChange = (option) => {
    onChange(option.value)
  }

  // Build select props conditionally
  const selectProps = {
    className: "timezone-selector",
    options: timezoneList,
    placeholder: "Choose timezone",
    value: timezoneOption,
    onChange: handleTimezoneChange,
  }

  if (menuPortalTarget) {
    selectProps.menuPortalTarget = menuPortalTarget
  }

  if (menuPosition) {
    selectProps.menuPosition = menuPosition
  }

  if (styles) {
    selectProps.styles = styles
  }

  return (
    <div className="timezone-wrapper">
      <label>
        Timezone:
      </label>
      <Select {...selectProps} />
    </div>
  )
}

export default TimezoneSelector
